import React from 'react';
import { cn } from 'lib/utils';
import { TabInfo } from 'pages/shipments/api/shipments';

interface CustomTabsProps {
  tabs: TabInfo[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
  disabled?: boolean;
}

export const CustomTabs: React.FC<CustomTabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className,
  disabled = false
}) => {
  if (tabs.length === 0) {
    return null;
  }

  return (
    <div className={cn("flex items-center border-b border-gray-200", disabled && "opacity-50 pointer-events-none select-none", className)}>
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        return (
          <button
            key={tab.id}
            disabled={disabled}
            onClick={() => {
              if (!disabled) onTabChange(tab.id);
            }}
            className={cn(
              "flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors",
              isActive
                ? "text-blue-600 border-blue-600"
                : "text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300"
            )}
          >
            <span>{tab.label}</span>
            <span className={cn(
              "px-2 py-0.5 text-xs font-medium rounded-full",
              isActive
                ? "bg-blue-100 text-blue-700"
                : "bg-gray-100 text-gray-600"
            )}>
              {tab.count}
            </span>
          </button>
        );
      })}
    </div>
  );
};
